import { authed } from './auth'
import type { Channel, Message, ReadState } from '@/types/api'

export type InboxMode = 'unread' | 'mentions'
export interface InboxEntry {
  channel: Channel
  guild_name?: string
  messages: Message[]
  jump_message_id: string
  last_message_id: string
  unread: boolean
}
export interface InboxPage {
  items: InboxEntry[]
  has_more: boolean
  next_before: string | null
}
export const inboxApi = {
  list: (params: { mode: InboxMode; include_muted: boolean; unread_only: boolean; before?: string | undefined }) => {
    const q = new URLSearchParams()
    for (const [key, value] of Object.entries(params)) if (value !== undefined) q.set(key, String(value))
    return authed<InboxPage>(`/users/@me/inbox?${q}`)
  },
  markRead: (channelId: string, messageId: string) => authed<ReadState>(`/channels/${channelId}/messages/${messageId}/ack?with_state=true`, { method: 'POST' }),
}
